<div class="form-host">
  @if ($showDialogHeader()) {
    <!-- The entity create dialog lends its title bar here so capability controls sit beside close. -->
    <header class="form-dialog-header">
      <h2 class="form-dialog-title">{{ $dialogTitle() }}</h2>
      <div class="form-dialog-header-actions">
        <wb-surface-capability-region [fields]="$capabilityFields()" [surfaceMode]="$surfaceMode()" />
        <button type="button" class="form-dialog-close" aria-label="Close" (click)="closeDialog()">
          <i class="fa-regular fa-xmark" aria-hidden="true"></i>
        </button>
      </div>
    </header>
  }
  <main class="form-body">
    @if ($errors().length > 0) {
      <div class="form-errors" role="alert">
        @for (error of $errors(); track $index) {
          <p>{{ error.message }}</p>
        }
      </div>
    }

    <div class="form-sections" cdkAccordion [multi]="true">
    @for (band of $bodyLayout(); track $index) {
      @if (band.type === 'columns') {
        <div class="section-columns" [style.grid-template-columns]="'repeat(' + band.columns.length + ', minmax(0, 1fr))'">
          @for (column of band.columns; track $index) {
            <div class="section-column">
              @for (item of column; track item.section.path) {
                @if (item.spacer) {
                  <div class="section-spacer" aria-hidden="true"></div>
                } @else if (item.section.related || $saveStrategy() !== 'patch' || (!item.$title() && !item.section.collapsible)) {
                  <wb-section
                    [path]="item.section.path"
                    [title]="item.$title()"
                    [description]="item.section.description"
                    [columns]="item.section.columns"
                    [layout]="item.section.layout"
                    [collapsible]="item.section.collapsible"
                    [collapsedByDefault]="item.section.collapsedByDefault"
                    [collapsedSummary]="item.section.collapsedSummary"
                    [readonly]="$page().section(item.section.path).$readonly()"
                    [fields]="item.fields"
                    [fieldGroups]="item.fieldGroups"
                    [related]="item.section.related"
                    [repeats]="item.repeats"
                    [resolver]="item.resolver"
                    [customRenderer]="item.customRenderer"
                    [customRendererInputs]="item.customRendererInputs"
                    [surfaceMode]="$surfaceMode()"
                    [page]="$page()"
                  />
                } @else {
                  <wb-panel [variant]="$panelVariant()" [title]="item.$title()" [description]="item.section.description" [collapsible]="item.section.collapsible" [collapsedByDefault]="item.section.collapsedByDefault">
                    <wb-section
                      [path]="item.section.path"
                      [columns]="item.section.columns"
                      [layout]="item.section.layout"
                      [readonly]="$page().section(item.section.path).$readonly()"
                      [fields]="item.fields"
                      [fieldGroups]="item.fieldGroups"
                      [repeats]="item.repeats"
                      [resolver]="item.resolver"
                      [customRenderer]="item.customRenderer"
                      [customRendererInputs]="item.customRendererInputs"
                      [surfaceMode]="$surfaceMode()"
                      [page]="$page()"
                    />
                  </wb-panel>
                }
              }
            </div>
          }
        </div>
      } @else {
        @if (band.section.spacer) {
          <div class="section-spacer" aria-hidden="true"></div>
        } @else if (band.section.section.related || $saveStrategy() !== 'patch' || (!band.section.$title() && !band.section.section.collapsible)) {
          <wb-section
            [path]="band.section.section.path"
            [title]="band.section.$title()"
            [description]="band.section.section.description"
            [columns]="band.section.section.columns"
            [layout]="band.section.section.layout"
            [collapsible]="band.section.section.collapsible"
            [collapsedByDefault]="band.section.section.collapsedByDefault"
            [collapsedSummary]="band.section.section.collapsedSummary"
            [readonly]="$page().section(band.section.section.path).$readonly()"
            [fields]="band.section.fields"
            [fieldGroups]="band.section.fieldGroups"
            [related]="band.section.section.related"
            [repeats]="band.section.repeats"
            [resolver]="band.section.resolver"
            [customRenderer]="band.section.customRenderer"
            [customRendererInputs]="band.section.customRendererInputs"
            [surfaceMode]="$surfaceMode()"
            [page]="$page()"
          />
        } @else {
          <wb-panel [variant]="$panelVariant()" [title]="band.section.$title()" [description]="band.section.section.description" [collapsible]="band.section.section.collapsible" [collapsedByDefault]="band.section.section.collapsedByDefault">
            <wb-section
              [path]="band.section.section.path"
              [columns]="band.section.section.columns"
              [layout]="band.section.section.layout"
              [readonly]="$page().section(band.section.section.path).$readonly()"
              [fields]="band.section.fields"
              [fieldGroups]="band.section.fieldGroups"
              [repeats]="band.section.repeats"
              [resolver]="band.section.resolver"
              [customRenderer]="band.section.customRenderer"
              [customRendererInputs]="band.section.customRendererInputs"
              [surfaceMode]="$surfaceMode()"
              [page]="$page()"
            />
          </wb-panel>
        }
      }
    }
    </div>
  </main>

  @if ($showFooter()) {
    <footer class="form-footer">
      @if ($createMoreConfig(); as createMore) {
        <span class="form-footer-create-more" [pTooltip]="$createMoreTooltip()" tooltipPosition="top">
          <wb-button-switch [checked]="$createMore()" [label]="createMore.label ?? 'Create more'" [disabled]="$busy()" (onToggle)="setCreateMore($event)" />
        </span>
      }
      <w-button [label]="$cancelLabel()" [size]="ButtonSize.Medium" [displayStyle]="ButtonDisplayStyle.Secondary" [disabled]="$busy()" (onClick)="cancel()" />
      <w-button [label]="$submitButtonLabel()" [tooltip]="$submitTooltip()" [size]="ButtonSize.Medium" [displayStyle]="ButtonDisplayStyle.Primary" [disabled]="$submitDisabled()" [loading]="$submitting() || $page().$saving()" (onClick)="submit()" />
    </footer>
  }
</div>
